"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function asyncGeneratorStep(e, t, a, i, o, r, n) {
  try {
    var s = e[r](n),
      c = s.value;
  } catch (e) {
    return void a(e);
  }
  s.done ? t(c) : Promise.resolve(c).then(i, o);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      a = arguments;
    return new Promise(function (i, o) {
      var r = e.apply(t, a);
      function n(e) {
        asyncGeneratorStep(r, i, o, n, s, "next", e);
      }
      function s(e) {
        asyncGeneratorStep(r, i, o, n, s, "throw", e);
      }
      n(void 0);
    });
  };
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var a = 0; a < t.length; a++) {
    var i = t[a];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}
function _createClass(e, t, a) {
  return t && _defineProperties(e.prototype, t), a && _defineProperties(e, a), e;
}
var axios = require("axios"),
  BUBBLE_API_HOST2 = "https://api2.getmybubble.io",
  Score = function () {
    return _createClass(function e() {
      _classCallCheck(this, e);
    }, [{
      key: "getScores",
      value: (e = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, a, i, o) {
        var r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return r = "".concat(BUBBLE_API_HOST2, "/fetch1?fun=LifeScore&get1=").concat(t, "&get2=").concat(a, "&get3=").concat(i, "&get4=").concat(o), e.abrupt("return", axios.get(r).then(function (e) {
                return e;
              }).catch(function (e) {
                return e;
              }));
            case 2:
            case "end":
              return e.stop();
          }
        }, e);
      })), function (t, a, i, o) {
        return e.apply(this, arguments);
      })
    }, {
      key: "getFormattedScoresData",
      value: function (e) {
        var t = e,
          a = [],
          i = JSON.parse(e.data_dictionary);
        for (var o in delete t.data_dictionary, delete t.id, console.log(i), t) !o.includes("dput") && i["d" + o] && a.push({
          name: i["d" + o],
          indicator: t[o],
          extras: this.getScoreExtras(i["d" + o], t[o])
        });
        return a;
      }
    }, {
      key: "getScoreExtras",
      value: function (e, t) {
        var a = {
            median_income: {
              percentage: this.gradeToPercentage(t, "positive"),
              image_path: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/income.svg",
              type: "positive",
              tool_tip: "The household income where half of households in a county earn more and half of households earn less."
            },
            family_unity: {
              percentage: this.gradeToPercentage(t, "positive"),
              image_path: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/family.svg",
              type: "positive",
              tool_tip: "An index reflecting family level features, such as births to unmarried women, divorce rate, single parents, percent married living jointly etc."
            },
            food_environment_index: {
              percentage: this.gradeToPercentage(t, "positive"),
              image_path: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/food.svg",
              type: "positive",
              tool_tip: "Index of factors contributing to a healthy food environment based on access and proximity to grocery stores, expenditures on fast foods, food prices etc"
            },
            access_to_exercise_opportunities: {
              percentage: this.gradeToPercentage(t, "positive"),
              image_path: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/exercise.svg",
              type: "positive",
              tool_tip: "Percentage of population with adequate access to locations for physical activity"
            },
            informal_civic_activity: {
              percentage: this.gradeToPercentage(t, "positive"),
              image_path: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/civic-activity.svg",
              type: "positive",
              tool_tip: "An index reflecting participation in both formal and informal activities, such as volunteering, participation in group activities, membership in clubs, recreational group activities etc."
            },
            adult_obesity: {
              percentage: this.gradeToPercentage(t, "negative"),
              image_path: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/obesity.svg",
              type: "negative",
              tool_tip: "Percentage of adult population age 20 and older that reports a BMI greater than or equal to 30"
            },
            violent_crime_rate: {
              percentage: this.gradeToPercentage(t, "negative"),
              image_path: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/crime-rate.svg",
              type: "negative",
              tool_tip: "Number of reported violent crime offenses per 100,000 population."
            },
            injury_death_rate: {
              percentage: this.gradeToPercentage(t, "negative"),
              image_path: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/death-rate.svg",
              type: "negative",
              tool_tip: "Number of deaths due to injury per 100,000 population."
            },
            air_pollution: {
              percentage: this.gradeToPercentage(t, "negative"),
              image_path: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/air-pollution.svg",
              type: "negative",
              tool_tip: "Average daily density of fine particulate matter in micrograms per cubic meter - PM 2.5"
            },
            frequent_mental_distress: {
              percentage: this.gradeToPercentage(t, "negative"),
              image_path: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/mental-distress.svg",
              type: "negative",
              tool_tip: "Percentage of adults reporting 14 or more days of poor physical or mental health by month"
            }
          },
          i = e.toLowerCase().replace(/\s/g, "_");
        return a[i] ? a[i] : {
          percentage: "",
          image_path: "",
          type: ""
        };
      }
    }, {
      key: "gradeToPercentage",
      value: function (e) {
        var t,
          a,
          i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "positive";
        switch (e) {
          case "Very Low":
            t = "20", a = "positive" == i ? "danger" : "success";
            break;
          case "Low":
            t = "40", a = "positive" == i ? "danger" : "success";
            break;
          case "Average":
            t = "50", a = "warning";
            break;
          case "High":
            t = "80", a = "positive" == i ? "success" : "danger";
            break;
          case "Very High":
            t = "100", a = "positive" == i ? "success" : "danger";
            break;
          default:
            t = "50", a = "warning";
        }
        return {
          outputPercentage: t,
          barType: a
        };
      }
    }]);
    var e;
  }();
module.exports = {
  Score: Score
};